import { DEFAULT_COURSES_ROUTE } from '../../constants';

export const GET_MASTER_COURSE_REQUEST = 'GET_MASTER_COURSE_REQUEST';
export const GET_MASTER_COURSE_SUCCESS = 'GET_MASTER_COURSE_SUCCESS';
export const GET_MASTER_COURSE_FAILURE = 'GET_MASTER_COURSE_FAILURE';
export const UPDATE_TOPIC_TREE_REQUEST = 'UPDATE_TOPIC_TREE_REQUEST';

export const getMasterCourserequest = (masterCourseId, version = 1) =>
    ({ type: GET_MASTER_COURSE_REQUEST, masterCourseId, version });

export const getMasterCourseSuccess = data =>
    ({ type: GET_MASTER_COURSE_SUCCESS,
        masterCourse: data.masterCourse,
        curriculumLevelDescriptions: data.curriculumLevelDescriptions,
        strandSubStrands: data.strandSubStrands
    });

export const getMasterCourseFailure = () =>
    ({ type: GET_MASTER_COURSE_FAILURE });

export const updateTopicTreeRequest = request =>
    ({ type: UPDATE_TOPIC_TREE_REQUEST, request });

export const SAVE_COURSE_REQUEST = 'SAVE_COURSE_REQUEST';
export const SAVE_COURSE_SUCCESS = 'SAVE_COURSE_SUCCESS';
export const SAVE_COURSE_VALIDATION_ERROR = 'SAVE_COURSE_VALIDATION_ERROR';
export const SAVE_COURSE_FAILURE = 'SAVE_COURSE_FAILURE';

export const saveCourse = request =>
    ({
        type: SAVE_COURSE_REQUEST,
        request
    });

export const saveCourseSuccess = newCourseId =>
    ({
        type: SAVE_COURSE_SUCCESS,
        newCourseId
    });

export const saveCourseValidationError = message =>
    ({
        type: SAVE_COURSE_VALIDATION_ERROR,
        message
    });

export const saveCourseFailure = () =>
    ({
        type: SAVE_COURSE_FAILURE
    });

export const PUBLISH_COURSE_REQUEST = 'PUBLISH_COURSE_REQUEST';
export const PUBLISH_COURSE_SUCCESS = 'PUBLISH_COURSE_SUCCESS';
export const PUBLISH_COURSE_FAILURE = 'PUBLISH_COURSE_FAILURE';

export const publishCourse = (courseId, productId, context) =>
    ({
        type: PUBLISH_COURSE_REQUEST,
        courseId,
        productId,
        context
    });

export const publishCourseSuccess = (context) => {
    context.router.history.push(DEFAULT_COURSES_ROUTE);
    return {
        type: PUBLISH_COURSE_SUCCESS
    };
};

export const publishCourseFailure = () =>
    ({
        type: PUBLISH_COURSE_FAILURE
    });


export const CANCEL_VALIDATION_ERRORS_REQUEST = 'CANCEL_VALIDATION_ERRORS_REQUEST';

export const cancelValidationErrorsRequest = () => ({
    type: CANCEL_VALIDATION_ERRORS_REQUEST
});

export const GET_DEFAULT_COURSE_REQUEST = 'GET_DEFAULT_COURSE_REQUEST';
export const GET_DEFAULT_COURSE_SUCCESS = 'GET_DEFAULT_COURSE_SUCCESS';
export const GET_DEFAULT_COURSE_FAILURE = 'GET_DEFAULT_COURSE_FAILURE';

export const getDefaultCourse = (
    productId,
    courseId,
    version,
    switchToMasterCourseId = null,
    switchToMasterCourseVersion = null
) =>
    ({
        type: GET_DEFAULT_COURSE_REQUEST,
        productId,
        courseId,
        version,
        switchToMasterCourseId,
        switchToMasterCourseVersion
    });

export const getDefaultCourseSuccess = ({ masterCourse, assignedSpineNodes, genericCourse, strandSubStrands, curriculumLevelDescriptions }) => {
    const assignedSpineItems = assignedSpineNodes.map(({ id }) => id);
    return {
        type: GET_DEFAULT_COURSE_SUCCESS,
        masterCourse,
        assignedSpineItems,
        pppCourse: genericCourse,
        strandSubStrands,
        curriculumLevelDescriptions,
        genericCourse
    };
};

export const getDefaultCourseFailure = () =>
    ({
        type: GET_DEFAULT_COURSE_FAILURE
    });

export const OPEN_ALERT_MODAL = 'OPEN_ALERT_MODAL';
export const CLOSE_ALERT_MODAL = 'CLOSE_ALERT_MODAL';

export const closeAlertModal = () =>
    ({
        type: CLOSE_ALERT_MODAL
    });

export const openAlertModal = () =>
    ({
        type: OPEN_ALERT_MODAL
    });

export const SET_COURSE_CREATOR_AS_MODIFIED = 'SET_COURSE_CREATOR_AS_MODIFIED';

export const setCourseCreatorAsModified = () =>
    ({
        type: SET_COURSE_CREATOR_AS_MODIFIED
    });
export const SET_COURSE_CREATOR_AS_CLEAN = 'SET_COURSE_CREATOR_AS_CLEAN';

export const setCourseCreatorAsClean = () =>
    ({
        type: SET_COURSE_CREATOR_AS_CLEAN
    });

export const HIDE_TOAST = 'HIDE_TOAST';

export const hideToastRequest = () =>
    ({
        type: HIDE_TOAST
    });

export const SHOW_PUBLISH_MODAL = 'SHOW_PUBLISH_MODAL';

export const showPublishModal = showModal =>
    ({
        type: SHOW_PUBLISH_MODAL,
        showModal
    });



// WEBPACK FOOTER //
// ./app/containers/course-creator/actions.js